import React from 'react';
import { Badge } from 'react-bootstrap';
import { ParametroDefinicaoDTO } from '../integracaoInterfaces';

const NOME_PARAMETRO_MOTIVO_PEP = 'MOTIVO_PEP';

interface ParametrizacaoPepProps {
    parametrosDefinicao: ParametroDefinicaoDTO[];
    listaMotivosInternos: any[];
    valoresEspecificos: { [key: string]: string };
    setValoresEspecificos: (v: { [key: string]: string }) => void;
}

const ParametrizacaoPepCard: React.FC<ParametrizacaoPepProps> = ({
    parametrosDefinicao, listaMotivosInternos, valoresEspecificos, setValoresEspecificos
}) => {

    const renderStatusBadge = (idMotivo: string) => {
        if (!idMotivo) return null;
        const motivo = listaMotivosInternos.find(m => String(m.id) === String(idMotivo));

        if (motivo) {
            if (motivo.pendenciaRecusa === 'R') return <Badge bg="danger" className="ms-2">Reprova</Badge>;
            else return <Badge bg="warning" text="dark" className="ms-2">Pendência</Badge>;
        }
        return null;
    };

    const defMotivoPep = parametrosDefinicao.find(p => p.nomeParametro === NOME_PARAMETRO_MOTIVO_PEP);
    const valorSelecionado = valoresEspecificos[NOME_PARAMETRO_MOTIVO_PEP] || '';

    return (
        <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light fw-bold">Parametrização PEP</div>
            <div className="card-body">
                {!defMotivoPep ? (
                    <small className="text-muted">Parâmetro MOTIVO_PEP não encontrado para esta integração.</small>
                ) : (
                    <div className="row mb-2 align-items-center">
                        <div className="col-5">
                            <input className="form-control form-control-sm" value="Motivo de Pendenciamento" disabled />
                        </div>
                        <div className="col-1 text-center">➡</div>
                        <div className="col-6 d-flex align-items-center">
                            <div style={{ flexGrow: 1 }}>
                                <select
                                    className="form-select form-select-sm"
                                    value={valorSelecionado}
                                    onChange={e => setValoresEspecificos({ ...valoresEspecificos, [NOME_PARAMETRO_MOTIVO_PEP]: e.target.value })}
                                >
                                    <option value="">Selecione Motivos (Padrão)...</option>
                                    {listaMotivosInternos.map(m => <option key={m.id} value={m.id}>{m.descricao}</option>)}
                                </select>
                            </div>
                            <div style={{ width: '80px', textAlign: 'left' }}>
                                {renderStatusBadge(valorSelecionado)}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ParametrizacaoPepCard;